import { cn } from '@/lib/utils'
import { type TourButtonProps, tourButtonVariants } from './tour-variants'

export function TourButton({
  children,
  variant,
  size,
  className,
  onClick,
  disabled,
  type = 'button',
  ...props
}: TourButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(tourButtonVariants({ variant, size }), className)}
      {...props}
    >
      {children}
    </button>
  )
}
